import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/ErrorEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const disabledQrApiImpl = async (id: string): Promise<Either<ErrorEntity, void>> => {
    try {
        const relativeUrl: string = `/qrcodes/disable-batch`;
        await di.get<HostApi>(HostApiName).post(relativeUrl, {
            "zip_token": id
        });
        return right(undefined);
    } catch (e) {
        return left({ code: "Error deshabilitando QR" });
    }
}

export default disabledQrApiImpl;